// extracted by mini-css-extract-plugin
export default {"wrapper":"Analytics_wrapper__DWXm3","ani":"Analytics_ani__Z4FsB"};